import { useLang } from "@/context/LanguageContext";
import { Sun, Medal, Building, Plane, Mountain, Landmark } from "lucide-react";

const icons = [Sun, Medal, Building, Plane, Mountain, Landmark];

export default function Location() {
  const { t } = useLang();

  return (
    <section
      id="location"
      data-testid="location-section"
      className="py-24 sm:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-6xl mx-auto px-6">
        {/* Section Label */}
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-[2px] bg-[#FF3B30]" />
          <span className="text-xs uppercase tracking-[0.3em] text-[#A3A3A3] font-body">
            {t.location.label}
          </span>
        </div>

        <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tight text-white mb-4">
          {t.location.title}
        </h2>

        <p className="text-sm sm:text-base text-[#A3A3A3] font-body leading-relaxed max-w-3xl mb-16">
          {t.location.intro}
        </p>

        {/* 6-item grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.location.reasons.map((reason, i) => {
            const Icon = icons[i];
            return (
              <div
                key={reason.title}
                data-testid={`location-reason-${i}`}
                className="group bg-[#111111] border border-[#262626] p-6 hover:border-[#FF3B30] transition-all hover:-translate-y-1"
              >
                <Icon className="w-7 h-7 text-[#FF3B30] mb-4 transition-transform group-hover:scale-110" />
                <h3 className="font-heading text-lg uppercase tracking-wider text-white mb-2">
                  {reason.title}
                </h3>
                <p className="text-xs text-[#A3A3A3] font-body leading-relaxed">
                  {reason.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
